import React, { useState } from 'react';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  TextField,
  InputAdornment,
  IconButton,
  Toolbar,
  Typography,
  Avatar,
  Tooltip,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Home,
  Search,
  Settings,
  Bolt,
  Group,
  CalendarMonth,
  LightMode,
  DarkMode,
  Menu,
  Send,
  Mic,
} from '@mui/icons-material';
import PatientListDialog from "../popup/PatientListDialog";
import { cleanHTML } from "../lib/helper";
import Dashboard from "./Dashboard";
import { useLocation, useNavigate } from "react-router-dom";
import FloatingMenu from "../common/FloatingMenu";
import { getUserLocalData } from "../lib/helper";
import DashboardLayout from './DashboardLayout';
const drawerWidth = 80;

const SidebarIcon = ({ icon, tooltip }) => (
  <Tooltip title={tooltip} placement="right">
    <IconButton sx={{ color: '#fff', my: 1 }}>{icon}</IconButton>
  </Tooltip>
);

const Dashboard2 = ({ children, active }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const chatsMessages = location?.state?.chatsMessages || [];
  const token = JSON.parse(localStorage.getItem("access_token"));
  const patient_id = localStorage.getItem("patient_id");
  const session_id = localStorage.getItem("session_id");
  const [query, setQuery] = useState("");
  const [messages, setMessages] = useState(chatsMessages);
  const [patientList, setPatientList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const { user_name } = getUserLocalData();

  const clearMessages = () => {
    setMessages([]); // Reset chat messages
  };

  return (
    <Box sx={{ display: 'flex', bgcolor: '#0e1629' }}>
      <CssBaseline />
      <DashboardLayout />
      {/* Main Area */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            pt: '70px', // space for fixed header
            width: { xs: '100%' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            height: '100vh',
          }}
        >
          {/* Title */}
          <Typography variant="h4" fontWeight={600} mb={1}>
            Patient Search
          </Typography>
          <Typography variant="body1" sx={{ color: '#b0b0b0', mb: 2 }}>
            Search by patient name, MRN, condition, or care program
          </Typography>

          {/* Search Box */}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              maxWidth: 600,
              background: 'linear-gradient(90deg, rgba(255,255,255,0.05), rgba(255,255,255,0.1))',
              borderRadius: '40px',
              px: 2,
              py: 1,
              boxShadow: '0 0 10px rgba(0,0,0,0.4)',
              mb: 3,
            }}
          >
            {/* Search icon at the start */}
            <Search sx={{ color: '#888', mr: 1 }} />

            {/* Styled input field */}
            <TextField
              fullWidth
              placeholder="Enter patient name, MRN, or search term..."
              variant="standard"
              InputProps={{
                disableUnderline: true,
                sx: {
                  color: '#fff',
                  fontSize: '1rem',
                },
              }}
              sx={{
                flex: 1,
                input: { color: 'white' },
              }}
            />

            {/* Send icon */}
            <IconButton sx={{ color: '#00f5c4' }}>
              <Send />
            </IconButton>

            {/* Mic icon */}
            <IconButton
              sx={{
                ml: 1,
                bgcolor: '#00f5c4',
                color: '#000',
                '&:hover': { bgcolor: '#00e6b0' },
              }}
            >
              <Mic />
            </IconButton>
          </Box>


          {/* Quick Search Tips Box */}
          <Box

            component={'div'}
            className='quick-search-box'
          >
            <Typography variant="subtitle1" fontWeight={500} mb={1} textAlign={'center'}>
              Quick Search Tips
            </Typography>
            <Box component={'div'} className='quick-search' sx={{ color: '#00f5c4', fontSize: '0.95rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <ul style={{ margin: 0 }}>
                <li><span className='dots'></span>Patient names</li>
                <li><span className='dots'></span>Care programs</li>
              </ul>
              <ul style={{ margin: 0, }}>
                <li><span className='dots'></span>Medical Record Numbers</li>
                <li><span className='dots'></span>Medical conditions</li>
              </ul>
            </Box>
          </Box>
        </Box>

      </Box>
      {open && (
        <PatientListDialog
          open={open}
          setOpen={setOpen}
          data={patientList}
          message={responseMessage}
          clearMessages={clearMessages}
        />
      )}
    </Box>
  );
}

export default Dashboard2;